<div
  class="footer-container dark-theme d-flex justify-content-start align-items-center"
  data-id="footerActionMenuBar"
  [class.show-container]="visible"
>
  <ng-content></ng-content>
</div>
